import { render, staticRenderFns } from "./ApprovalAdmin.vue?vue&type=template&id=585ac6e9&scoped=true"
import script from "./ApprovalAdmin.vue?vue&type=script&lang=js"
export * from "./ApprovalAdmin.vue?vue&type=script&lang=js"
import style0 from "./ApprovalAdmin.vue?vue&type=style&index=0&id=585ac6e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585ac6e9",
  null
  
)

export default component.exports